// import React, { useContext, useEffect, useState } from "react";
// import { useLocation, useNavigate, useParams } from "react-router-dom";
// import { TenantContext } from "../Tenants/TenantContext";
// import { AgreementContext } from "./AgreementContext";
// import { useUnitDetails } from "../Properties/UnitDetailsContext";
// import { useAuth } from "../../Utility/AuthProvider";
// import APICall from "../../Utility/APICall";
// import { paths } from "../../Utility/Constants";
// import CongratsModal from "./CongratsModal";
// import CustomButton from "../Buttons/CustomButton";
// import { FaEye, FaUser, FaIdCard, FaFileAlt } from "react-icons/fa";

// const AgreementOverview = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const { unitId } = useParams();
//   const { jwt } = useAuth();

//    // Get data from navigation state
//    const agreementBody = location.state?.agreementBody || null;
//    const unit = location.state?.unit || null;
//    const tenantList = location.state?.tenantList || [];
//    const isUpdate = location.state?.isUpdate || false;
//    const originalAgreement = location.state?.originalAgreement || null;

//     // Get contexts
//   const { agreementData } = useContext(AgreementContext);
//   const { unitDetails, fetchUnitDetails } = useUnitDetails();

//    // Component state
//    const [loading, setLoading] = useState(false);
//    const [error, setError] = useState(null);
//    const [isModalOpen, setIsModalOpen] = useState(false);
//    const [agreementResponse, setAgreementResponse] = useState(null);
//    const [createdTenants, setCreatedTenants] = useState([]);

//    // State for image modal
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [isImageModalOpen, setImageModalOpen] = useState(false);

//    // Filter valid tenants
//    const validTenants = tenantList.filter(tenant => Object.keys(tenant).length > 0);

//    useEffect(() => {
//     console.log("=== AGREEMENT OVERVIEW DEBUG ===");
//     console.log("Location state:", location.state);
//     console.log("agreementBody:", agreementBody);
//     console.log("modifiedAgreementData:", modifiedAgreementData);
//     console.log("originalAgreement:", originalAgreement);
//     console.log("isModifying:", isModifying);
//     console.log("agreementData from context:", agreementData);
//     console.log("================================");
//   }, []);

//   // Add these new state variables
//   const modifiedAgreementData = location.state?.modifiedAgreementData || null;
//   const isModifying = location.state?.isModifying || false;

//     // Fetch unit details on mount
//     useEffect(() => {
//       if (unitId && !unitDetails) {
//         fetchUnitDetails(unitId);
//       }
//     }, [unitId, unitDetails, fetchUnitDetails]);

//       // Format date for API
//   const formatDateForAPI = (date) => {
//     if (!date) return null;
//     const d = new Date(date);
//     const year = d.getFullYear();
//     const month = String(d.getMonth() + 1).padStart(2, "0");
//     const day = String(d.getDate()).padStart(2, "0");
//     const hours = String(d.getHours()).padStart(2, "0");
//     const minutes = String(d.getMinutes()).padStart(2, "0");
//     const seconds = String(d.getSeconds()).padStart(2, "0");
//     return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
//   };

//   // Get initials for profile display
//   const getInitials = (firstName, lastName) => {
//     const first = firstName ? firstName.charAt(0).toUpperCase() : '';
//     const last = lastName ? lastName.charAt(0).toUpperCase() : '';
//     return `${first}${last}`;
//   };

//   // Get profile image for tenant
//   const getTenantProfileImage = (tenant) => {
//     if (tenant.media?.profile_picture?.location) {
//       return tenant.media.profile_picture.location;
//     }
//     if (tenant.profile_picture) {
//       return typeof tenant.profile_picture === 'string'
//         ? tenant.profile_picture
//         : URL.createObjectURL(tenant.profile_picture);
//     }
//     return null;
//   };

//   // View image in modal
//   const viewImage = (imageUrl) => {
//     setSelectedImage(imageUrl);
//     setImageModalOpen(true);
//   };

//   // Helper function to get the right data source
//   // ADD THIS HELPER FUNCTION
//   const getDisplayData = () => {
//     if (isModifying && modifiedAgreementData) {
//       return {
//         rent: modifiedAgreementData.rent,
//         security_deposit: modifiedAgreementData.security_deposit,
//         maintenance: modifiedAgreementData.maintenance,
//         due_date: modifiedAgreementData.due_date,
//         tenure: modifiedAgreementData.tenure,
//         staying_from: modifiedAgreementData.staying_from,
//         vacating_on: modifiedAgreementData.vacating_on,
//         is_advance_rent: modifiedAgreementData.is_advance_rent,
//       };
//     }

//     // Fallback to existing logic for new agreements
//     return {
//       rent: agreementBody?.rent || agreementData?.agreementDetails?.monthlyRent,
//       security_deposit:
//         agreementBody?.security_deposit ||
//         agreementData?.agreementDetails?.securityDeposit,
//       maintenance:
//         agreementBody?.maintenance ||
//         agreementData?.agreementDetails?.maintenanceCharge,
//       due_date:
//         agreementBody?.due_date ||
//         agreementData?.agreementDetails?.formattedDueDate,
//       tenure: agreementBody?.tenure || agreementData?.agreementDetails?.tenure,
//       staying_from:
//         agreementBody?.staying_from ||
//         agreementData?.agreementDetails?.stayingFrom,
//       vacating_on:
//         agreementBody?.vacating_on ||
//         agreementData?.agreementDetails?.vacatingDate,
//       is_advance_rent:
//         agreementBody?.is_advance_rent ??
//         agreementData?.agreementDetails?.advanceRent,
//     };
//   };

//   // Helper function to format dates for display
//   const formatDateForDisplay = (dateString) => {
//     if (!dateString) return "Not set";
//     try {
//       const date = new Date(dateString);
//       return date.toLocaleDateString("en-GB", {
//         day: "2-digit",
//         month: "long",
//         year: "numeric",
//       });
//     } catch (error) {
//       return "Invalid date";
//     }
//   };

//   // Handle file uploads to cloud storage (simplified version)
//   const handleFileUploads = async (tenantList) => {
//     // This would typically upload files to cloud storage
//     // For now, we'll simulate this process
//     const tenantIds = [];

//     for (const tenant of tenantList) {
//       if (Object.keys(tenant).length === 0) continue;

//       let tenantId = tenant.entity_id;

//       // If tenant is not in DB, add them first
//       if (!tenant.tenant_in_db && !tenant.tenant_in_agreement) {
//         try {
//           const addTenantResponse = await APICall(
//             "POST",
//             paths.tenant.add,
//             {
//               first_name: tenant.first_name,
//               last_name: tenant.last_name,
//               mobile: tenant.mobile,
//             },
//             undefined,
//             jwt
//           );

//           if (addTenantResponse.status === "success") {
//             tenantId = addTenantResponse.response.entity_id;
//           } else {
//             throw new Error("Failed to add tenant");
//           }
//         } catch (error) {
//           console.error("Error adding tenant:", error);
//           throw error;
//         }
//       }

//       // Here you would typically upload files to cloud storage
//       // and then update tenant with media URLs
//       if (tenant.is_media_modified) {
//         try {
//           // Simulate media upload - in real implementation, upload to cloud first
//           const mediaData = {
//             profile_picture: tenant.profile_picture ? "uploaded_url" : null,
//             aadhar_front: tenant.aadhar_front ? "uploaded_url" : null,
//             aadhar_back: tenant.aadhar_back ? "uploaded_url" : null,
//             pan: tenant.pan ? "uploaded_url" : null,
//             rent_agreement: tenant.rent_agreement ? "uploaded_url" : null,
//           };

//           await APICall(
//             "PUT",
//             paths.tenant.update,
//             {
//               tenant_id: tenantId,
//               media: JSON.stringify(mediaData),
//             },
//             undefined,
//             jwt
//           );
//         } catch (error) {
//           console.error("Error updating tenant media:", error);
//         }
//       }

//       tenantIds.push(tenantId);
//     }

//     return tenantIds;
//   };

//   // Handle agreement creation/update
//   const handleCreateAgreement = async () => {
//     if (validTenants.length === 0) {
//       alert("Please add at least one tenant before creating the agreement.");
//       return;
//     }

//     setLoading(true);
//     setError(null);

//     try {
//       // Upload files and get tenant IDs
//       const tenantIds = await handleFileUploads(validTenants);

//       // Prepare request body - use modifiedAgreementData if modifying
//       const requestBody = isModifying
//         ? {
//             agreement_id: originalAgreement.entity_id,
//             unit_id: originalAgreement.unit_id,
//             tenant_id: tenantIds,
//             building_id: originalAgreement.building_id,
//             rent: modifiedAgreementData.rent,
//             staying_from: modifiedAgreementData.staying_from,
//             unit_name: originalAgreement.unit_name,
//             building_name: originalAgreement.building_name,
//             is_advance_rent: originalAgreement.is_advance_rent,
//             due_date: modifiedAgreementData.due_date,
//             security_deposit: modifiedAgreementData.security_deposit,
//             maintenance: modifiedAgreementData.maintenance,
//             tenure: modifiedAgreementData.tenure,
//             vacating_on: modifiedAgreementData.vacating_on,
//           }
//         : // {
//           //     // ... existing requestBody for new agreements ...
//           //     unit_id: unitDetails?.unit?.entity_id || agreementBody?.unitId,
//           //     tenant_id: tenantIds,
//           //     building_id:
//           //       unitDetails?.unit?.building_id || agreementBody?.building_id,
//           //     rent:
//           //       agreementBody?.rent ||
//           //       agreementData?.agreementDetails?.monthlyRent,
//           //     staying_from: formatDateForAPI(
//           //       agreementBody?.staying_from ||
//           //         agreementData?.agreementDetails?.stayingFrom
//           //     ),
//           //     unit_name: unitDetails?.unit?.unit_name || agreementBody?.unit_name,
//           //     building_name:
//           //       unitDetails?.unit?.building_name || agreementBody?.building_name,
//           //     is_advance_rent:
//           //       agreementBody?.is_advance_rent ??
//           //       agreementData?.agreementDetails?.advanceRent ??
//           //       false,
//           //     due_date:
//           //       agreementBody?.due_date ||
//           //       agreementData?.agreementDetails?.formattedDueDate,
//           //     security_deposit:
//           //       agreementBody?.security_deposit ||
//           //       agreementData?.agreementDetails?.securityDeposit,
//           //     maintenance:
//           //       agreementBody?.maintenance ||
//           //       agreementData?.agreementDetails?.maintenanceCharge,
//           //     tenure:
//           //       agreementBody?.tenure || agreementData?.agreementDetails?.tenure,
//           //     vacating_on: formatDateForAPI(
//           //       agreementBody?.vacating_on ||
//           //         agreementData?.agreementDetails?.vacatingDate
//           //     ),
//           //   };

//           // Prepare agreement request body
//           // const requestBody = {
//           //   unit_id: unitDetails?.unit?.entity_id || agreementBody?.unitId,
//           //   tenant_id: tenantIds,
//           //   building_id:
//           //     unitDetails?.unit?.building_id || agreementBody?.building_id,
//           //   rent:
//           //     agreementBody?.rent || agreementData?.agreementDetails?.monthlyRent,
//           //   staying_from: formatDateForAPI(
//           //     agreementBody?.staying_from ||
//           //       agreementData?.agreementDetails?.stayingFrom
//           //   ),
//           //   unit_name: unitDetails?.unit?.unit_name || agreementBody?.unit_name,
//           //   building_name:
//           //     unitDetails?.unit?.building_name || agreementBody?.building_name,
//           //   is_advance_rent:
//           //     agreementBody?.is_advance_rent ??
//           //     agreementData?.agreementDetails?.advanceRent ??
//           //     false,
//           //   due_date:
//           //     agreementBody?.due_date ||
//           //     agreementData?.agreementDetails?.formattedDueDate,
//           //   security_deposit:
//           //     agreementBody?.security_deposit ||
//           //     agreementData?.agreementDetails?.securityDeposit,
//           //   maintenance:
//           //     agreementBody?.maintenance ||
//           //     agreementData?.agreementDetails?.maintenanceCharge,
//           //   tenure:
//           //     agreementBody?.tenure || agreementData?.agreementDetails?.tenure,
//           //   vacating_on: formatDateForAPI(
//           //     agreementBody?.vacating_on ||
//           //       agreementData?.agreementDetails?.vacatingDate
//           //   ),
//           // };

//           {
//             // ... your existing requestBody for new agreements ...
//             unit_id: unitDetails?.unit?.entity_id || agreementBody?.unitId,
//             tenant_id: tenantIds,
//             building_id:
//               unitDetails?.unit?.building_id || agreementBody?.building_id,
//             rent:
//               agreementBody?.rent ||
//               agreementData?.agreementDetails?.monthlyRent,
//             staying_from: formatDateForAPI(
//               agreementBody?.staying_from ||
//                 agreementData?.agreementDetails?.stayingFrom
//             ),
//             unit_name: unitDetails?.unit?.unit_name || agreementBody?.unit_name,
//             building_name:
//               unitDetails?.unit?.building_name || agreementBody?.building_name,
//             is_advance_rent:
//               agreementBody?.is_advance_rent ??
//               agreementData?.agreementDetails?.advanceRent ??
//               false,
//             due_date:
//               agreementBody?.due_date ||
//               agreementData?.agreementDetails?.formattedDueDate,
//             security_deposit:
//               agreementBody?.security_deposit ||
//               agreementData?.agreementDetails?.securityDeposit,
//             maintenance:
//               agreementBody?.maintenance ||
//               agreementData?.agreementDetails?.maintenanceCharge,
//             tenure:
//               agreementBody?.tenure || agreementData?.agreementDetails?.tenure,
//             vacating_on: formatDateForAPI(
//               agreementBody?.vacating_on ||
//                 agreementData?.agreementDetails?.vacatingDate
//             ),
//           };

//       console.log("Agreement request body:", requestBody);

//       // let response;
//       // if (isUpdate && originalAgreement) {
//       //   // Update existing agreement
//       //   requestBody.agreement_id = originalAgreement.entity_id;
//       // response = await APICall(
//       //   "PUT",
//       //   paths.agreement.update,
//       //   requestBody,
//       //   undefined,
//       //   jwt
//       // );
//       const response = await APICall(
//         isModifying ? "PUT" : isUpdate ? "PUT" : "POST",
//         isModifying
//           ? paths.agreement.update
//           : isUpdate
//             ? paths.agreement.update
//             : paths.agreement.add,
//         requestBody,
//         undefined,
//         jwt
//       );
//       // } else {
//       //   // Create new agreement
//       //   response = await APICall(
//       //     "POST",
//       //     paths.agreement.add,
//       //     requestBody,
//       //     undefined,
//       //     jwt
//       //   );
//       // }

//       console.log("Agreement API response:", response);

//       if (response.status === "success") {
//         setAgreementResponse(response);

//         // Update unit status
//         await updateUnitStatus(response);

//         setIsModalOpen(true);
//       } else {
//         throw new Error(response.message || "Failed to create agreement");
//       }
//     } catch (error) {
//       console.error("Error creating agreement:", error);
//       setError(error.message || "An unexpected error occurred");
//       alert(`Error: ${error.message || "An unexpected error occurred"}`);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const getButtonText = () => {
//     if (loading) {
//       return isModifying
//         ? "Updating Agreement..."
//         : isUpdate
//           ? "Updating..."
//           : "Creating...";
//     }
//     return isModifying
//       ? "Update Agreement"
//       : isUpdate
//         ? "Update Agreement"
//         : "Create Agreement";
//   };

//   // Update unit status after agreement creation
//   const updateUnitStatus = async (agreementResponse) => {
//     try {
//       const updatePromises = [];

//       // Update unit status
//       const unitUpdateBody = {
//         agreement_id: agreementResponse.response.entity_id,
//         rent: agreementResponse.response.rent?.[0]?.rent || agreementBody?.rent,
//         unit_id: agreementResponse.response.unit_id,
//         occupancy_status: "rented",
//         tenant_name: validTenants[0]
//           ? `${validTenants[0].first_name} ${validTenants[0].last_name}`
//           : "",
//       };

//       updatePromises.push(
//         APICall("PUT", paths.unit.update, unitUpdateBody, undefined, jwt)
//       );

//       // Update building tenant count
//       let shouldUpdateTenantCount = false;
//       let countToUpdate = 0;

//       if (isUpdate && originalAgreement) {
//         const newTenantCount = validTenants.length;
//         const oldTenantCount = originalAgreement.tenant_id?.length || 0;

//         if (newTenantCount !== oldTenantCount) {
//           shouldUpdateTenantCount = true;
//           countToUpdate = newTenantCount - oldTenantCount;
//         }
//       } else {
//         shouldUpdateTenantCount = true;
//         countToUpdate = validTenants.length;
//       }

//       if (shouldUpdateTenantCount) {
//         const buildingUpdateBody = {
//           building_id: agreementResponse.response.building_id,
//           tenant_count: countToUpdate,
//         };
//         updatePromises.push(
//           APICall(
//             "PUT",
//             paths.building.updateCount,
//             buildingUpdateBody,
//             undefined,
//             jwt
//           )
//         );
//       }

//       await Promise.all(updatePromises);
//     } catch (error) {
//       console.error("Error updating unit/building status:", error);
//     }
//   };

//   const handleEditTenant = () => {
//     navigate(-1); // Go back to tenant list
//   };

//   const handleModalCloseAndNavigate = () => {
//     setIsModalOpen(false);
//     if (unitDetails?.unit?.entity_id) {
//       navigate(`/dashboard/my-properties/${unitDetails.unit.entity_id}`, {
//         state: {
//           entity_id: agreementResponse?.response?.unit_id,
//           needsUpdate: true,
//           updateData: {
//             agreement_id: agreementResponse?.response?.entity_id,
//             rent: agreementResponse?.response?.rent?.[0]?.rent,
//             unit_id: agreementResponse?.response?.unit_id,
//             occupancy_status: "rented",
//             tenant_name: validTenants[0]
//               ? `${validTenants[0].first_name} ${validTenants[0].last_name}`
//               : "",
//             isUpdate,
//             building_id: agreementResponse?.response?.building_id,
//             tenantCount: validTenants.length,
//             originalAgreementTenantCount:
//               originalAgreement?.tenant_id?.length || 0,
//           },
//         },
//       });
//     } else {
//       navigate("/dashboard/my-properties");
//     }
//   };

//   if (!agreementBody && !agreementData) {
//     return (
//       <div className="min-h-screen flex items-center justify-center">
//         <p>No agreement data found. Please start from the beginning.</p>
//       </div>
//     );
//   }

//   const displayData = getDisplayData();

//   return (
//     <div className="min-h-screen w-full p-6">
//       <div className="container mx-auto max-w-4xl">
//         {/* Header */}
//         <div className="mb-6">
//           <h1 className="text-2xl font-bold mb-2">Agreement Overview</h1>
//           {unit && (
//             <div className="text-gray-600">
//               <p className="font-medium">{unit.unit_name}</p>
//               <p>
//                 {unit.building_name}, {unit.address}
//               </p>
//             </div>
//           )}
//         </div>

//         {/* Tenant Details Section */}
//         <div className="bg-white rounded-lg shadow-sm border p-6 mb-6">
//           <div className="flex justify-between items-center mb-4">
//             <h2 className="text-xl font-semibold">Tenant Details</h2>
//             <button
//               onClick={handleEditTenant}
//               className="text-blue-600 hover:text-blue-800 font-medium"
//             >
//               Edit
//             </button>
//           </div>

//           <div className="space-y-4">
//             {validTenants.map((tenant, index) => (
//               <div
//                 key={tenant.entity_id || index}
//                 className="flex items-center justify-between p-4 bg-gray-50 rounded-lg"
//               >
//                 <div className="flex items-center space-x-4">
//                   <div className="w-12 h-12 rounded-full bg-blue-500 text-white flex items-center justify-center font-medium">
//                     {tenant.profile_picture ? (
//                       <img
//                         src={
//                           typeof tenant.profile_picture === "string"
//                             ? tenant.profile_picture
//                             : URL.createObjectURL(tenant.profile_picture)
//                         }
//                         alt="Profile"
//                         className="w-full h-full rounded-full object-cover"
//                       />
//                     ) : (
//                       getInitials(tenant.first_name, tenant.last_name)
//                     )}
//                   </div>
//                   <div>
//                     <p className="font-medium">
//                       {tenant.first_name} {tenant.last_name}
//                     </p>
//                     <p className="text-sm text-gray-500">{tenant.mobile}</p>
//                   </div>
//                 </div>
//                 {index === 0 ? (
//                   <span className="bg-yellow-100 text-yellow-800 text-xs px-2 py-1 rounded-full font-medium">
//                     Primary
//                   </span>
//                 ) : (
//                   <span className="bg-yellow-100 text-yellow-800 text-xs px-2 py-1 rounded-full font-medium">
//                     Secondary
//                   </span>
//                 )}
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Agreement Details Section */}
//         <div className="bg-white rounded-lg shadow-sm border p-6 mb-6">
//           {/* <h2 className="text-xl font-semibold mb-4">Agreement Details</h2> */}
//           <h2 className="text-xl font-semibold mb-4">
//             {" "}
//             {isModifying ? "Modified Agreement Details" : "Agreement Details"}
//           </h2>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//             <div className="space-y-3">
//               <div>
//                 <p className="text-sm text-gray-500">Monthly Rent</p>
//                 <p className="font-medium">
//                   {/* ₹
//                   {agreementBody?.rent ||
//                     agreementData?.agreementDetails?.monthlyRent} */}
//                   ₹{displayData.rent || "0"}
//                 </p>
//               </div>
//               <div>
//                 <p className="text-sm text-gray-500">Due Date</p>
//                 <p className="font-medium">
//                   {/* {agreementBody?.due_date ||
//                     agreementData?.agreementDetails?.formattedDueDate}
//                   th of every month */}
//                   {displayData.due_date || "Not set"}th of every month
//                 </p>
//               </div>
//               <div>
//                 <p className="text-sm text-gray-500">Security Deposit</p>
//                 <p className="font-medium">
//                   {/* ₹
//                   {agreementBody?.security_deposit ||
//                     agreementData?.agreementDetails?.securityDeposit} */}
//                   ₹{displayData.security_deposit || "0"}
//                 </p>
//               </div>
//               <div>
//                 <p className="text-sm text-gray-500">Maintenance Charge</p>
//                 <p className="font-medium">
//                   {/* ₹
//                   {agreementBody?.maintenance ||
//                     agreementData?.agreementDetails?.maintenanceCharge} */}
//                   ₹{displayData.maintenance || "0"}
//                 </p>
//               </div>
//             </div>

//             <div className="space-y-3">
//               <div>
//                 <p className="text-sm text-gray-500">Staying From</p>
//                 <p className="font-medium">
//                   {/* {new Date(
//                     agreementBody?.staying_from ||
//                       agreementData?.agreementDetails?.stayingFrom
//                   ).toLocaleDateString()} */}
//                   {formatDateForDisplay(displayData.staying_from)}
//                 </p>
//               </div>
//               <div>
//                 <p className="text-sm text-gray-500">Tenure</p>
//                 <p className="font-medium">
//                   {/* {agreementBody?.tenure ||
//                     agreementData?.agreementDetails?.tenure} */}
//                   {displayData.tenure || "Not set"}
//                 </p>
//               </div>
//               <div>
//                 <p className="text-sm text-gray-500">Vacating On</p>
//                 <p className="font-medium">
//                   {/* {new Date(
//                     agreementBody?.vacating_on ||
//                       agreementData?.agreementDetails?.vacatingDate
//                   ).toLocaleDateString()} */}
//                   {formatDateForDisplay(displayData.vacating_on)}
//                 </p>
//               </div>
//               <div>
//                 <p className="text-sm text-gray-500">Advance Rent</p>
//                 <p className="font-medium">
//                   {/* {(agreementBody?.is_advance_rent ??
//                   agreementData?.agreementDetails?.advanceRent)
//                     ? "Yes"
//                     : "No"} */}
//                   {displayData.is_advance_rent ? "Yes" : "No"}
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Unit Details Section */}
//         <div className="bg-white rounded-lg shadow-sm border p-6 mb-6">
//           <h2 className="text-xl font-semibold mb-4">Unit Details</h2>

//           {unitDetails?.unit ? (
//             <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//               <div>
//                 <p className="text-sm text-gray-500">Unit Name</p>
//                 <p className="font-medium">{unitDetails.unit.unit_name}</p>
//               </div>
//               <div>
//                 <p className="text-sm text-gray-500">Building</p>
//                 <p className="font-medium">{unitDetails.unit.building_name}</p>
//               </div>
//               <div>
//                 <p className="text-sm text-gray-500">Address</p>
//                 <p className="font-medium">{unitDetails.unit.address}</p>
//               </div>
//               <div>
//                 <p className="text-sm text-gray-500">BHK</p>
//                 <p className="font-medium">{unitDetails.unit.bhk}</p>
//               </div>
//               <div>
//                 <p className="text-sm text-gray-500">Area</p>
//                 <p className="font-medium">{unitDetails.unit.unit_area}</p>
//               </div>
//               <div>
//                 <p className="text-sm text-gray-500">Furnishing</p>
//                 <p className="font-medium">
//                   {unitDetails.unit.furnishing_status}
//                 </p>
//               </div>
//             </div>
//           ) : (
//             <p className="text-gray-500">Loading unit details...</p>
//           )}
//         </div>

//         {/* Error Message */}
//         {error && (
//           <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg">
//             <p className="text-red-800">{error}</p>
//           </div>
//         )}

//         {/* Create Agreement Button */}
//         <div className="flex justify-end">
//           <CustomButton
//             tailwindClasses={`px-8 py-3 text-lg font-medium ${
//               loading
//                 ? "bg-gray-400 text-gray-700 cursor-not-allowed"
//                 : "bg-green-500 text-white hover:bg-green-600"
//             }`}
//             // label={
//             //   loading
//             //     ? isUpdate
//             //       ? "Updating..."
//             //       : "Creating..."
//             //     : isUpdate
//             //       ? "Update Agreement"
//             //       : "Create Agreement"
//             // }
//             label={getButtonText()}
//             onClick={handleCreateAgreement}
//             disabled={loading || validTenants.length === 0}
//           />
//         </div>

//         {/* Success Modal */}
//         {agreementResponse && (
//           <CongratsModal
//             open={isModalOpen}
//             onClose={handleModalCloseAndNavigate}
//             agreementData={agreementBody || agreementData?.agreementDetails}
//             tenantData={validTenants}
//             unitData={unitDetails?.unit}
//             addAgreement={agreementResponse}
//             isUpdate={isUpdate}
//           />
//         )}
//       </div>
//     </div>
//   );
// };

// export default AgreementOverview;

// import React, { useContext, useEffect, useState } from "react";
// import { useLocation, useNavigate, useParams } from "react-router-dom";
// import { TenantContext } from "../Tenants/TenantContext";
// import { AgreementContext } from "./AgreementContext";
// import { useUnitDetails } from "../Properties/UnitDetailsContext";
// import { useAuth } from "../../Utility/AuthProvider";
// import APICall from "../../Utility/APICall";
// import { paths } from "../../Utility/Constants";
// import CongratsModal from "./CongratsModal";
// import CustomButton from "../Buttons/CustomButton";
// import { FaEye, FaUser, FaIdCard, FaFileAlt } from "react-icons/fa";

// const AgreementOverview = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const { unitId } = useParams();
//   const { jwt } = useAuth();

//   // Get data from navigation state
//   const agreementBody = location.state?.agreementBody || null;
//   const unit = location.state?.unit || null;
//   const tenantList = location.state?.tenantList || [];
//   const isUpdate = location.state?.isUpdate || false;
//   const originalAgreement = location.state?.originalAgreement || null;

//   // Get contexts
//   const { agreementData } = useContext(AgreementContext);
//   const { unitDetails, fetchUnitDetails } = useUnitDetails();

//   // Component state
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [agreementResponse, setAgreementResponse] = useState(null);
//   const [createdTenants, setCreatedTenants] = useState([]);

//   // State for image modal
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [isImageModalOpen, setImageModalOpen] = useState(false);

//   // Filter valid tenants
//   const validTenants = tenantList.filter(
//     (tenant) => Object.keys(tenant).length > 0
//   );

//   console.log("=== AGREEMENT OVERVIEW DEBUG ===");
//   console.log("Location state:", location.state);
//   console.log("agreementBody:", agreementBody);
//   console.log("validTenants:", validTenants);
//   console.log("agreementData from context:", agreementData);
//   console.log("================================");

//   // Fetch unit details on mount
//   useEffect(() => {
//     if (unitId && !unitDetails) {
//       fetchUnitDetails(unitId);
//     }
//   }, [unitId, unitDetails, fetchUnitDetails]);

//   // Format date for API
//   const formatDateForAPI = (date) => {
//     if (!date) return null;
//     const d = new Date(date);
//     const year = d.getFullYear();
//     const month = String(d.getMonth() + 1).padStart(2, "0");
//     const day = String(d.getDate()).padStart(2, "0");
//     const hours = String(d.getHours()).padStart(2, "0");
//     const minutes = String(d.getMinutes()).padStart(2, "0");
//     const seconds = String(d.getSeconds()).padStart(2, "0");
//     return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
//   };

//   // Get initials for profile display
//   const getInitials = (firstName, lastName) => {
//     const first = firstName ? firstName.charAt(0).toUpperCase() : "";
//     const last = lastName ? lastName.charAt(0).toUpperCase() : "";
//     return `${first}${last}`;
//   };

//   // Get profile image for tenant
//   const getTenantProfileImage = (tenant) => {
//     if (tenant.media?.profile_picture?.location) {
//       return tenant.media.profile_picture.location;
//     }
//     if (tenant.profile_picture) {
//       return typeof tenant.profile_picture === "string"
//         ? tenant.profile_picture
//         : URL.createObjectURL(tenant.profile_picture);
//     }
//     return null;
//   };

//   // View image in modal
//   const viewImage = (imageUrl) => {
//     setSelectedImage(imageUrl);
//     setImageModalOpen(true);
//   };

//   // Create or update tenants in backend
//   const handleTenantsCreation = async () => {
//     const tenantIds = [];
//     const createdTenantsData = [];

//     try {
//       for (let i = 0; i < validTenants.length; i++) {
//         const tenant = validTenants[i];
//         let tenantId = null;

//         if (tenant.tenant_in_agreement) {
//           // Tenant already exists in agreement
//           tenantIds.push(tenant.entity_id);
//           createdTenantsData.push(tenant);
//           continue;
//         }

//         if (!tenant.tenant_in_db) {
//           // Create new tenant
//           console.log(
//             "Creating new tenant:",
//             tenant.first_name,
//             tenant.last_name
//           );

//           const createTenantBody = {
//             first_name: tenant.first_name,
//             last_name: tenant.last_name,
//             mobile: tenant.mobile,
//           };

//           const createResponse = await APICall(
//             "POST",
//             paths.tenant.add,
//             createTenantBody,
//             undefined,
//             jwt
//           );

//           if (createResponse.status === "success") {
//             tenantId = createResponse.response.entity_id;
//             console.log("New tenant created with ID:", tenantId);
//           } else {
//             throw new Error(
//               `Failed to create tenant: ${createResponse.message}`
//             );
//           }
//         } else {
//           // Use existing tenant ID
//           tenantId = tenant.entity_id;
//           console.log("Using existing tenant ID:", tenantId);
//         }

//         // Update tenant with media if available
//         if (tenant.media && Object.keys(tenant.media).length > 0) {
//           console.log("Updating tenant media for ID:", tenantId);

//           const updateTenantBody = {
//             tenant_id: tenantId,
//             media: JSON.stringify(tenant.media),
//           };

//           const updateResponse = await APICall(
//             "PUT",
//             paths.tenant.update,
//             updateTenantBody,
//             undefined,
//             jwt
//           );

//           if (updateResponse.status !== "success") {
//             console.warn(
//               "Failed to update tenant media:",
//               updateResponse.message
//             );
//           }
//         }

//         tenantIds.push(tenantId);
//         createdTenantsData.push({ ...tenant, entity_id: tenantId });
//       }

//       return { tenantIds, createdTenantsData };
//     } catch (error) {
//       console.error("Error in tenant creation/update:", error);
//       throw error;
//     }
//   };

//   const handleCreateAgreement = async () => {
//     setLoading(true);
//     setError(null);

//     try {
//       console.log("Starting agreement creation process...");

//       // Step 1: Create/Update tenants and get their IDs
//       const { tenantIds, createdTenantsData } = await handleTenantsCreation();
//       setCreatedTenants(createdTenantsData);

//       console.log("Created tenant IDs:", tenantIds);

//       // Step 2: Prepare agreement request body
//       const requestBody = {
//         unit_id: agreementData.agreementDetails.unitId || unitId,
//         tenant_id: tenantIds,
//         building_id: unitDetails?.unit?.building_id,
//         rent: agreementData.agreementDetails.monthlyRent,
//         staying_from: formatDateForAPI(
//           agreementData.agreementDetails.stayingFrom
//         ),
//         unit_name: unitDetails?.unit?.unit_name,
//         building_name: unitDetails?.unit?.building_name,
//         is_advance_rent: agreementData.agreementDetails.advanceRent,
//         due_date: agreementData.agreementDetails.formattedDueDate,
//         security_deposit: agreementData.agreementDetails.securityDeposit,
//         maintenance: agreementData.agreementDetails.maintenanceCharge,
//         tenure: agreementData.agreementDetails.tenure,
//         vacating_on: formatDateForAPI(
//           agreementData.agreementDetails.vacatingDate
//         ),
//       };

//       console.log("Agreement request body:", requestBody);

//       // Step 3: Create agreement
//       const response = await APICall(
//         isUpdate ? "PUT" : "POST",
//         isUpdate ? paths.agreement.update : paths.agreement.add,
//         isUpdate
//           ? { ...requestBody, agreement_id: originalAgreement.entity_id }
//           : requestBody,
//         undefined,
//         jwt
//       );

//       console.log("Agreement API response:", response);

//       if (response.status === "success") {
//         setAgreementResponse(response);
//         setIsModalOpen(true);
//       } else {
//         throw new Error(response.message || "Failed to create agreement");
//       }
//     } catch (error) {
//       console.error("Error creating agreement:", error);
//       setError(error.message || "An unexpected error occurred");
//       alert(`Error: ${error.message || "An unexpected error occurred"}`);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleModalCloseAndNavigate = () => {
//     setIsModalOpen(false);
//     if (agreementResponse?.response?.unit_id) {
//       navigate(
//         `/dashboard/my-properties/${agreementResponse.response.unit_id}`,
//         {
//           state: {
//             entity_id: agreementResponse.response.unit_id,
//             needsUpdate: true,
//             updateData: {
//               agreement_id: agreementResponse.response.entity_id,
//               rent: agreementResponse.response.rent?.[0]?.rent,
//               unit_id: agreementResponse.response.unit_id,
//               occupancy_status: "rented",
//               tenant_name: validTenants[0]
//                 ? `${validTenants[0].first_name} ${validTenants[0].last_name}`
//                 : "N/A",
//               isUpdate,
//               building_id: agreementResponse.response.building_id,
//               tenantCount: validTenants.length,
//               originalAgreementTenantCount:
//                 originalAgreement?.tenant_id?.length || 0,
//             },
//           },
//         }
//       );
//     } else {
//       navigate("/dashboard/my-properties");
//     }
//   };

//   // Document component for showing tenant documents
//   const TenantDocuments = ({ tenant }) => {
//     const documents = [
//       { key: "profile_picture", label: "Profile", icon: FaUser },
//       { key: "aadhar_front", label: "Aadhar Front", icon: FaIdCard },
//       { key: "aadhar_back", label: "Aadhar Back", icon: FaIdCard },
//       { key: "pan", label: "PAN", icon: FaFileAlt },
//       { key: "rent_agreement", label: "Agreement", icon: FaFileAlt },
//     ];

//     const getDocumentUrl = (docKey) => {
//       if (tenant.media?.[docKey]?.location)
//         return tenant.media[docKey].location;
//       if (tenant[docKey]) {
//         return typeof tenant[docKey] === "string"
//           ? tenant[docKey]
//           : URL.createObjectURL(tenant[docKey]);
//       }
//       return null;
//     };

//     return (
//       <div className="grid grid-cols-5 gap-2 mt-3">
//         {documents.map((doc) => {
//           const hasDoc = getDocumentUrl(doc.key);
//           const IconComponent = doc.icon;
//           return (
//             <div
//               key={doc.key}
//               className={`flex flex-col items-center p-2 rounded text-xs ${
//                 hasDoc
//                   ? "bg-green-50 text-green-700 border border-green-200"
//                   : "bg-gray-50 text-gray-400 border border-gray-200"
//               }`}
//             >
//               <IconComponent size={16} className="mb-1" />
//               <span className="text-center">{doc.label}</span>
//               {hasDoc && (
//                 <button
//                   onClick={() => viewImage(hasDoc)}
//                   className="mt-1 text-blue-600 hover:text-blue-800"
//                 >
//                   <FaEye size={12} />
//                 </button>
//               )}
//             </div>
//           );
//         })}
//       </div>
//     );
//   };

//   if (!agreementData?.agreementDetails) {
//     return (
//       <div className="p-8">
//         <div className="text-center">
//           <p className="text-gray-500">
//             No agreement data found. Please start the agreement process again.
//           </p>
//           <button
//             onClick={() =>
//               navigate(`/dashboard/my-properties/${unitId}/add-agreement`)
//             }
//             className="mt-4 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
//           >
//             Start Agreement
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen w-full p-6">
//       <div className="container mx-auto max-w-4xl">
//         <h1 className="text-2xl font-bold mb-8">Agreement Overview</h1>

//         {/* Tenants Section */}
//         <section className="mb-8">
//           <div className="flex justify-between items-center mb-4">
//             <h2 className="text-xl font-semibold">Tenants</h2>
//             <button
//               onClick={() => navigate(-1)}
//               className="text-blue-600 hover:text-blue-800 text-sm font-medium"
//             >
//               Edit
//             </button>
//           </div>
//           <div className="bg-white rounded-lg shadow-sm border p-6">
//             {validTenants.length > 0 ? (
//               <div className="space-y-4">
//                 {validTenants.map((tenant, index) => (
//                   <div
//                     key={tenant.entity_id || `tenant-${index}`}
//                     className="border border-gray-200 rounded-lg p-4"
//                   >
//                     <div className="flex items-start space-x-4">
//                       {/* Profile Picture */}
//                       <div className="w-16 h-16 rounded-full bg-blue-500 text-white flex items-center justify-center font-medium flex-shrink-0">
//                         {getTenantProfileImage(tenant) ? (
//                           <img
//                             src={getTenantProfileImage(tenant)}
//                             alt="Profile"
//                             className="w-full h-full rounded-full object-cover cursor-pointer"
//                             onClick={() =>
//                               viewImage(getTenantProfileImage(tenant))
//                             }
//                           />
//                         ) : (
//                           getInitials(tenant.first_name, tenant.last_name)
//                         )}
//                       </div>

//                       {/* Tenant Info */}
//                       <div className="flex-1">
//                         <div className="flex items-center space-x-2">
//                           <p className="font-medium text-gray-900">
//                             {tenant.first_name} {tenant.last_name}
//                           </p>
//                           {index === 0 && (
//                             <span className="bg-yellow-100 text-yellow-800 text-xs px-2 py-1 rounded-full font-medium">
//                               Primary
//                             </span>
//                           )}
//                           {tenant.tenant_in_db && (
//                             <span className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full font-medium">
//                               Existing
//                             </span>
//                           )}
//                         </div>
//                         <p className="text-sm text-gray-500 mt-1">
//                           {tenant.mobile}
//                         </p>

//                         {/* Documents */}
//                         <TenantDocuments tenant={tenant} />
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             ) : (
//               <p className="text-gray-500">
//                 No tenants added for this agreement.
//               </p>
//             )}
//           </div>
//         </section>

//         {/* Agreement Details Section */}
//         <section className="mb-8">
//           <h2 className="text-xl font-semibold mb-4">Agreement Details</h2>
//           <div className="bg-white rounded-lg shadow-sm border p-6">
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//               <div>
//                 <h3 className="font-medium text-gray-700 mb-3">
//                   Financial Details
//                 </h3>
//                 <div className="space-y-2">
//                   <div className="flex justify-between">
//                     <span className="text-gray-600">Monthly Rent:</span>
//                     <span className="font-medium">
//                       ₹{agreementData.agreementDetails.monthlyRent}
//                     </span>
//                   </div>
//                   <div className="flex justify-between">
//                     <span className="text-gray-600">Security Deposit:</span>
//                     <span className="font-medium">
//                       ₹{agreementData.agreementDetails.securityDeposit}
//                     </span>
//                   </div>
//                   <div className="flex justify-between">
//                     <span className="text-gray-600">Maintenance:</span>
//                     <span className="font-medium">
//                       ₹{agreementData.agreementDetails.maintenanceCharge}
//                     </span>
//                   </div>
//                   <div className="flex justify-between">
//                     <span className="text-gray-600">Advance Rent:</span>
//                     <span className="font-medium">
//                       {agreementData.agreementDetails.advanceRent
//                         ? "Yes"
//                         : "No"}
//                     </span>
//                   </div>
//                 </div>
//               </div>

//               <div>
//                 <h3 className="font-medium text-gray-700 mb-3">
//                   Agreement Terms
//                 </h3>
//                 <div className="space-y-2">
//                   <div className="flex justify-between">
//                     <span className="text-gray-600">Due Date:</span>
//                     <span className="font-medium">
//                       {agreementData.agreementDetails.formattedDueDate} of every
//                       month
//                     </span>
//                   </div>
//                   <div className="flex justify-between">
//                     <span className="text-gray-600">Tenure:</span>
//                     <span className="font-medium">
//                       {agreementData.agreementDetails.tenure}
//                     </span>
//                   </div>
//                   <div className="flex justify-between">
//                     <span className="text-gray-600">Staying From:</span>
//                     <span className="font-medium">
//                       {new Date(
//                         agreementData.agreementDetails.stayingFrom
//                       ).toLocaleDateString()}
//                     </span>
//                   </div>
//                   <div className="flex justify-between">
//                     <span className="text-gray-600">Vacating On:</span>
//                     <span className="font-medium">
//                       {new Date(
//                         agreementData.agreementDetails.vacatingDate
//                       ).toLocaleDateString()}
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* Unit Details Section */}
//         <section className="mb-8">
//           <h2 className="text-xl font-semibold mb-4">Unit Details</h2>
//           <div className="bg-white rounded-lg shadow-sm border p-6">
//             {unitDetails?.unit ? (
//               <div className="space-y-2">
//                 <div className="flex justify-between">
//                   <span className="text-gray-600">Unit Name:</span>
//                   <span className="font-medium">
//                     {unitDetails.unit.unit_name}
//                   </span>
//                 </div>
//                 <div className="flex justify-between">
//                   <span className="text-gray-600">Building:</span>
//                   <span className="font-medium">
//                     {unitDetails.unit.building_name}
//                   </span>
//                 </div>
//                 <div className="flex justify-between">
//                   <span className="text-gray-600">Address:</span>
//                   <span className="font-medium">
//                     {unitDetails.unit.address}
//                   </span>
//                 </div>
//               </div>
//             ) : (
//               <p className="text-gray-500">Loading unit details...</p>
//             )}
//           </div>
//         </section>

//         {/* Create Agreement Button */}
//         <div className="flex justify-end">
//           <CustomButton
//             tailwindClasses={`px-8 py-3 text-lg font-medium ${
//               loading
//                 ? "bg-gray-400 text-gray-700 cursor-not-allowed"
//                 : "bg-green-500 text-white hover:bg-green-600"
//             }`}
//             label={
//               loading
//                 ? isUpdate
//                   ? "Updating..."
//                   : "Creating..."
//                 : isUpdate
//                   ? "Update Agreement"
//                   : "Create Agreement"
//             }
//             onClick={handleCreateAgreement}
//             disabled={loading}
//           />
//         </div>

//         {error && <p className="text-red-500 mt-4 text-right">{error}</p>}

//         {/* Congratulations Modal */}
//         {isModalOpen && agreementResponse && (
//           <CongratsModal
//             open={isModalOpen}
//             onClose={handleModalCloseAndNavigate}
//             agreementData={agreementData.agreementDetails}
//             tenantData={
//               createdTenants.length > 0 ? createdTenants : validTenants
//             }
//             unitData={unitDetails?.unit}
//             addAgreement={agreementResponse}
//           />
//         )}

//         {/* Image Modal */}
//         {isImageModalOpen && selectedImage && (
//           <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75 z-50">
//             <div className="relative max-w-4xl max-h-screen p-4">
//               <button
//                 onClick={() => setImageModalOpen(false)}
//                 className="absolute top-2 right-2 text-white hover:text-gray-300 text-2xl z-10"
//               >
//                 ×
//               </button>
//               <img
//                 src={selectedImage}
//                 alt="Document preview"
//                 className="max-w-full max-h-full object-contain"
//               />
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default AgreementOverview;

import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { TenantContext } from "../Tenants/TenantContext";
import { AgreementContext } from "./AgreementContext";
import { useUnitDetails } from "../Properties/UnitDetailsContext";
import { useAuth } from "../../Utility/AuthProvider";
import APICall from "../../Utility/APICall";
import { paths } from "../../Utility/Constants";
import CongratsModal from "./CongratsModal";
import CustomButton from "../Buttons/CustomButton";
import { FaEye, FaUser, FaIdCard, FaFileAlt } from "react-icons/fa";
import {
  getTenantProfileImageURL,
  getTenantDocumentURL,
  getTenantInitials,
} from "../../Utility/tenantFileUtils";
import CustomImage, { IMAGE_TYPES } from "../../Utility/CustomImage";
import { GetMediaURL } from "../../Utility/APICall";

const AgreementOverview = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { unitId, agreementId } = useParams(); // Added agreementId for modify flow
  const { jwt } = useAuth();

  // Get data from navigation state
  const agreementBody = location.state?.agreementBody || null;
  const unit = location.state?.unit || null;
  const tenantList = location.state?.tenantList || [];
  const isUpdate = location.state?.isUpdate || false;
  const originalAgreement = location.state?.originalAgreement || null;

  // NEW: Get modify flow data
  const modifiedAgreementData = location.state?.modifiedAgreementData || null;
  const isModifying = location.state?.isModifying || false;

  // Get contexts
  const { agreementData } = useContext(AgreementContext);
  const { unitDetails, fetchUnitDetails } = useUnitDetails();

  // Component state
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [agreementResponse, setAgreementResponse] = useState(null);
  const [createdTenants, setCreatedTenants] = useState([]);

  // State for image modal
  const [selectedImage, setSelectedImage] = useState(null);
  const [isImageModalOpen, setImageModalOpen] = useState(false);

  // Filter valid tenants
  const validTenants = tenantList.filter(
    (tenant) => Object.keys(tenant).length > 0
  );

  console.log("=== AGREEMENT OVERVIEW DEBUG ===");
  console.log("Location state:", location.state);
  console.log("isModifying:", isModifying);
  console.log("modifiedAgreementData:", modifiedAgreementData);
  console.log("originalAgreement:", originalAgreement);
  console.log("agreementBody:", agreementBody);
  console.log("validTenants:", validTenants);
  console.log("agreementData from context:", agreementData);
  console.log("================================");

  // Fetch unit details on mount
  useEffect(() => {
    if (unitId && !unitDetails) {
      fetchUnitDetails(unitId);
    }
  }, [unitId, unitDetails, fetchUnitDetails]);

  // Format date for API
  const formatDateForAPI = (date) => {
    if (!date) return null;
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");
    const seconds = String(d.getSeconds()).padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  // Get initials for profile display
  // const getInitials = (firstName, lastName) => {
  //   const first = firstName ? firstName.charAt(0).toUpperCase() : "";
  //   const last = lastName ? lastName.charAt(0).toUpperCase() : "";
  //   return `${first}${last}`;
  // };

  // Get profile image for tenant
  // const getTenantProfileImage = (tenant) => {
  //   if (tenant.media?.profile_picture?.location) {
  //     return tenant.media.profile_picture.location;
  //   }
  //   if (tenant.profile_picture) {
  //     return typeof tenant.profile_picture === "string"
  //       ? tenant.profile_picture
  //       : URL.createObjectURL(tenant.profile_picture);
  //   }
  //   return null;
  // };

  // Enhanced viewImage function for AgreementOverview
  const viewImage = async (imageUrl, tenant = null, docType = null) => {
    console.log("🖼️ AgreementOverview viewImage called:", {
      imageUrl,
      tenant,
      docType,
    });

    if (!imageUrl) {
      console.error("❌ No image URL provided to AgreementOverview viewImage");
      alert("Image not available - no URL provided");
      return;
    }

    // Debug tenant data if provided
    if (tenant && docType) {
      debugTenantData(tenant, `AgreementOverview-${docType}`);
    }

    // Test image loading with authentication
    // console.log("🧪 Testing image loadability with auth...");
    // const isLoadable = await testImageLoadability(imageUrl, jwt);

    // if (!isLoadable) {
    //   console.error("❌ Image failed to load in AgreementOverview:", imageUrl);
    //   alert(
    //     `Failed to load image. Please check network connection.\nURL: ${imageUrl.substring(0, 50)}...`
    //   );
    //   return;
    // }

    console.log("✅ Image verified, opening modal in AgreementOverview");
    setSelectedImage(imageUrl);
    setImageModalOpen(true);
  };

  // Create or update tenants in backend
  const handleTenantsCreation = async () => {
    const tenantIds = [];
    const createdTenantsData = [];

    try {
      for (let i = 0; i < validTenants.length; i++) {
        const tenant = validTenants[i];
        let tenantId = null;

        if (tenant.tenant_in_agreement) {
          // Tenant already exists in agreement
          tenantIds.push(tenant.entity_id);
          createdTenantsData.push(tenant);
          continue;
        }

        if (!tenant.tenant_in_db) {
          // Create new tenant
          console.log(
            "Creating new tenant:",
            tenant.first_name,
            tenant.last_name
          );

          const createTenantBody = {
            first_name: tenant.first_name,
            last_name: tenant.last_name,
            mobile: tenant.mobile,
          };

          const createResponse = await APICall(
            "POST",
            paths.tenant.add,
            createTenantBody,
            undefined,
            jwt
          );

          if (createResponse.status === "success") {
            tenantId = createResponse.response.entity_id;
            console.log("New tenant created with ID:", tenantId);
          } else {
            throw new Error(
              `Failed to create tenant: ${createResponse.message}`
            );
          }
        } else {
          // Use existing tenant ID
          tenantId = tenant.entity_id;
          console.log("Using existing tenant ID:", tenantId);
        }

        // Update tenant with media if available
        if (tenant.media && Object.keys(tenant.media).length > 0) {
          console.log("Updating tenant media for ID:", tenantId);

          const updateTenantBody = {
            tenant_id: tenantId,
            media: JSON.stringify(tenant.media),
          };

          const updateResponse = await APICall(
            "PUT",
            paths.tenant.update,
            updateTenantBody,
            undefined,
            jwt
          );

          if (updateResponse.status !== "success") {
            console.warn(
              "Failed to update tenant media:",
              updateResponse.message
            );
          }
        }

        tenantIds.push(tenantId);
        createdTenantsData.push({ ...tenant, entity_id: tenantId });
      }

      return { tenantIds, createdTenantsData };
    } catch (error) {
      console.error("Error in tenant creation/update:", error);
      throw error;
    }
  };

  // Get initials for profile display
  const getInitials = (firstName, lastName) => {
    const first = firstName ? firstName.charAt(0).toUpperCase() : "";
    const last = lastName ? lastName.charAt(0).toUpperCase() : "";
    return `${first}${last}`;
  };

  // NEW: Handle modify agreement
  // const handleModifyAgreement = async () => {
  //   setLoading(true);
  //   setError(null);

  //   try {
  //     console.log("Starting agreement modification process...");

  //     // Step 1: Handle tenant updates
  //     const { tenantIds, createdTenantsData } = await handleTenantsCreation();
  //     setCreatedTenants(createdTenantsData);

  //     console.log("Updated tenant IDs:", tenantIds);

  //     // Step 2: Prepare agreement update request body
  //     const requestBody = {
  //       agreement_id: agreementId,
  //       rent: modifiedAgreementData.rent,
  //       security_deposit: modifiedAgreementData.security_deposit,
  //       maintenance: modifiedAgreementData.maintenance,
  //       due_date: modifiedAgreementData.due_date,
  //       tenure: modifiedAgreementData.tenure,
  //       staying_from: modifiedAgreementData.staying_from,
  //       vacating_on: modifiedAgreementData.vacating_on,
  //       tenant_id: tenantIds, // Updated tenant list
  //     };

  //     console.log("Agreement update request body:", requestBody);

  //     // Step 3: Update agreement
  //     const response = await APICall(
  //       "PUT",
  //       paths.agreement.update,
  //       requestBody,
  //       undefined,
  //       jwt
  //     );

  //     console.log("Agreement update API response:", response);

  //     if (response.status === "success") {
  //       console.log("✅ Agreement modified successfully");

  //       // Navigate back to unit details with success message
  //       navigate(`/dashboard/my-properties/${originalAgreement.unit_id}`, {
  //         state: {
  //           entity_id: originalAgreement.unit_id,
  //           needsUpdate: true,
  //           updateData: {
  //             agreement_id: agreementId,
  //             rent: modifiedAgreementData.rent,
  //             unit_id: originalAgreement.unit_id,
  //             occupancy_status: "rented",
  //             tenant_name: validTenants[0]
  //               ? `${validTenants[0].first_name} ${validTenants[0].last_name}`
  //               : "N/A",
  //             isUpdate: true,
  //             building_id: originalAgreement.building_id,
  //             tenantCount: validTenants.length,
  //             originalAgreementTenantCount:
  //               originalAgreement?.tenant_id?.length || 0,
  //           },
  //         },
  //       });
  //     } else {
  //       throw new Error(response.message || "Failed to modify agreement");
  //     }
  //   } catch (error) {
  //     console.error("Error modifying agreement:", error);
  //     setError(error.message || "An unexpected error occurred");
  //     alert(`Error: ${error.message || "An unexpected error occurred"}`);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const debugTenantData = (tenant, context = "unknown") => {
    console.log(`=== DEBUG TENANT DATA (${context}) ===`);
    console.log("Full tenant object:", tenant);
    console.log("Tenant media:", tenant.media);
    console.log("Direct properties:", {
      profile_picture: tenant.profile_picture,
      aadhar_front: tenant.aadhar_front,
      aadhar_back: tenant.aadhar_back,
      pan: tenant.pan,
      rent_agreement: tenant.rent_agreement,
    });
    console.log("=====================================");
  };

  const testImageLoad = async (url) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(true);
      img.onerror = () => reject(false);
      img.src = url;
    });
  };

  const handleModifyAgreement = async () => {
    setLoading(true);
    setError(null);

    try {
      console.log("Starting agreement modification process...");

      // Step 1: Handle tenant updates
      const { tenantIds, createdTenantsData } = await handleTenantsCreation();
      setCreatedTenants(createdTenantsData);

      console.log("Updated tenant IDs:", tenantIds);

      // Step 2: Prepare agreement update request body
      const requestBody = {
        agreement_id: agreementId,
        rent: modifiedAgreementData.rent,
        security_deposit: modifiedAgreementData.security_deposit,
        maintenance: modifiedAgreementData.maintenance,
        due_date: modifiedAgreementData.due_date,
        tenure: modifiedAgreementData.tenure,
        staying_from: modifiedAgreementData.staying_from,
        vacating_on: modifiedAgreementData.vacating_on,
        tenant_id: tenantIds, // Updated tenant list
      };

      console.log("Agreement update request body:", requestBody);

      // Step 3: Update agreement
      const response = await APICall(
        "PUT",
        paths.agreement.update,
        requestBody,
        undefined,
        jwt
      );

      console.log("Agreement update API response:", response);

      if (response.status === "success") {
        console.log("✅ Agreement modified successfully");

        // NEW: Set response and show modal instead of direct navigation
        setAgreementResponse(response);
        setIsModalOpen(true);
      } else {
        throw new Error(response.message || "Failed to modify agreement");
      }
    } catch (error) {
      console.error("Error modifying agreement:", error);
      setError(error.message || "An unexpected error occurred");
      alert(`Error: ${error.message || "An unexpected error occurred"}`);
    } finally {
      setLoading(false);
    }
  };

  const handleModifyModalCloseAndNavigate = () => {
    setIsModalOpen(false);

    // Navigate back to unit details with success message
    navigate(`/dashboard/my-properties/${originalAgreement.unit_id}`, {
      state: {
        forceRefresh: true,
        entity_id: originalAgreement.unit_id,
        needsUpdate: true,
        updateData: {
          agreement_id: agreementId,
          rent: modifiedAgreementData.rent,
          unit_id: originalAgreement.unit_id,
          occupancy_status: "rented",
          tenant_name: validTenants[0]
            ? `${validTenants[0].first_name} ${validTenants[0].last_name}`
            : "N/A",
          isUpdate: true,
          building_id: originalAgreement.building_id,
          tenantCount: validTenants.length,
          originalAgreementTenantCount:
            originalAgreement?.tenant_id?.length || 0,
        },
      },
    });
  };

  const handleCreateAgreement = async () => {
    setLoading(true);
    setError(null);

    try {
      console.log("Starting agreement creation process...");

      // Step 1: Create/Update tenants and get their IDs
      const { tenantIds, createdTenantsData } = await handleTenantsCreation();
      setCreatedTenants(createdTenantsData);

      console.log("Created tenant IDs:", tenantIds);

      // Step 2: Prepare agreement request body
      const requestBody = {
        unit_id: agreementData.agreementDetails.unitId || unitId,
        tenant_id: tenantIds,
        building_id: unitDetails?.unit?.building_id,
        rent: agreementData.agreementDetails.monthlyRent,
        staying_from: formatDateForAPI(
          agreementData.agreementDetails.stayingFrom
        ),
        unit_name: unitDetails?.unit?.unit_name,
        building_name: unitDetails?.unit?.building_name,
        is_advance_rent: agreementData.agreementDetails.advanceRent,
        due_date: agreementData.agreementDetails.formattedDueDate,
        security_deposit: agreementData.agreementDetails.securityDeposit,
        maintenance: agreementData.agreementDetails.maintenanceCharge,
        tenure: agreementData.agreementDetails.tenure,
        vacating_on: formatDateForAPI(
          agreementData.agreementDetails.vacatingDate
        ),
      };

      console.log("Agreement request body:", requestBody);

      // Step 3: Create agreement
      const response = await APICall(
        isUpdate ? "PUT" : "POST",
        isUpdate ? paths.agreement.update : paths.agreement.add,
        isUpdate
          ? { ...requestBody, agreement_id: originalAgreement.entity_id }
          : requestBody,
        undefined,
        jwt
      );

      console.log("Agreement API response:", response);

      if (response.status === "success") {
        setAgreementResponse(response);
        setIsModalOpen(true);
      } else {
        throw new Error(response.message || "Failed to create agreement");
      }
    } catch (error) {
      console.error("Error creating agreement:", error);
      setError(error.message || "An unexpected error occurred");
      alert(`Error: ${error.message || "An unexpected error occurred"}`);
    } finally {
      setLoading(false);
    }
  };

  // NEW: Main handler that routes to correct function
  const handleAgreementAction = () => {
    if (isModifying) {
      handleModifyAgreement();
    } else {
      handleCreateAgreement();
    }
  };

  const handleModalCloseAndNavigate = () => {
    setIsModalOpen(false);
    if (agreementResponse?.response?.unit_id) {
      navigate(
        `/dashboard/my-properties/${agreementResponse.response.unit_id}`,
        {
          state: {
            forceRefresh: true,
            entity_id: agreementResponse.response.unit_id,
            needsUpdate: true,
            updateData: {
              agreement_id: agreementResponse.response.entity_id,
              rent: agreementResponse.response.rent?.[0]?.rent,
              unit_id: agreementResponse.response.unit_id,
              occupancy_status: "rented",
              tenant_name: validTenants[0]
                ? `${validTenants[0].first_name} ${validTenants[0].last_name}`
                : "N/A",
              isUpdate,
              building_id: agreementResponse.response.building_id,
              tenantCount: validTenants.length,
              originalAgreementTenantCount:
                originalAgreement?.tenant_id?.length || 0,
            },
          },
        }
      );
    } else {
      navigate("/dashboard/my-properties");
    }
  };

  // Document component for showing tenant documents
  // const TenantDocuments = ({ tenant }) => {
  //   const documents = [
  //     { key: "profile_picture", label: "Profile", icon: FaUser },
  //     { key: "aadhar_front", label: "Aadhar Front", icon: FaIdCard },
  //     { key: "aadhar_back", label: "Aadhar Back", icon: FaIdCard },
  //     { key: "pan", label: "PAN", icon: FaFileAlt },
  //     { key: "rent_agreement", label: "Agreement", icon: FaFileAlt },
  //   ];

  //   const getDocumentUrl = (docKey) => {
  //     if (tenant.media?.[docKey]?.location)
  //       return tenant.media[docKey].location;
  //     if (tenant[docKey]) {
  //       return typeof tenant[docKey] === "string"
  //         ? tenant[docKey]
  //         : URL.createObjectURL(tenant[docKey]);
  //     }
  //     return null;
  //   };

  //   return (
  //     <div className="grid grid-cols-5 gap-2 mt-3">
  //       {documents.map((doc) => {
  //         const hasDoc = getDocumentUrl(doc.key);
  //         const IconComponent = doc.icon;
  //         return (
  //           <div
  //             key={doc.key}
  //             className={`flex flex-col items-center p-2 rounded text-xs ${
  //               hasDoc
  //                 ? "bg-green-50 text-green-700 border border-green-200"
  //                 : "bg-gray-50 text-gray-400 border border-gray-200"
  //             }`}
  //           >
  //             <IconComponent size={16} className="mb-1" />
  //             <span className="text-center">{doc.label}</span>
  //             {hasDoc && (
  //               <button
  //                 onClick={() => viewImage(hasDoc)}
  //                 className="mt-1 text-blue-600 hover:text-blue-800"
  //               >
  //                 <FaEye size={12} />
  //               </button>
  //             )}
  //           </div>
  //         );
  //       })}
  //     </div>
  //   );
  // };
  // Enhanced TenantDocuments component with debugging
  const TenantDocuments = ({ tenant }) => {
    // Debug tenant data structure
    debugTenantData(tenant, "AgreementOverview-TenantDocuments");

    const documents = [
      { key: "profile_picture", label: "Profile", icon: FaUser },
      { key: "aadhar_front", label: "Aadhar Front", icon: FaIdCard },
      { key: "aadhar_back", label: "Aadhar Back", icon: FaIdCard },
      { key: "pan", label: "PAN", icon: FaFileAlt },
      { key: "rent_agreement", label: "Agreement", icon: FaFileAlt },
    ];

    const getDocumentURL = (docKey) => {
      console.log(`🔍 AgreementOverview getting URL for ${docKey}...`);
      const url = getTenantDocumentURL(tenant, docKey, { quality: 80 });
      console.log(`📄 AgreementOverview generated URL for ${docKey}:`, url);
      return url;
    };

    return (
      <div className="grid grid-cols-5 gap-2 mt-3">
        {documents.map((doc) => {
          const docUrl = getDocumentURL(doc.key);
          const IconComponent = doc.icon;

          return (
            <div
              key={doc.key}
              className={`flex flex-col items-center p-2 rounded text-xs ${
                docUrl
                  ? "bg-green-50 text-green-700 border border-green-200"
                  : "bg-gray-50 text-gray-400 border border-gray-200"
              }`}
            >
              <IconComponent size={16} className="mb-1" />
              <span className="text-center">{doc.label}</span>
              {docUrl && (
                <button
                  onClick={async () => {
                    console.log(
                      `🖱️ AgreementOverview clicked to view ${doc.key}`
                    );
                    await viewImage(docUrl, tenant, doc.key);
                  }}
                  className="mt-1 text-blue-600 hover:text-blue-800"
                >
                  <FaEye size={12} />
                </button>
              )}
              {!docUrl && (
                <span className="mt-1 text-gray-400 text-xs">N/A</span>
              )}
            </div>
          );
        })}
      </div>
    );
  };

  // NEW: Get agreement details for display (works for both create and modify)
  const getAgreementDetails = () => {
    if (isModifying && modifiedAgreementData) {
      return {
        monthlyRent: modifiedAgreementData.rent,
        securityDeposit: modifiedAgreementData.security_deposit,
        maintenanceCharge: modifiedAgreementData.maintenance,
        formattedDueDate: modifiedAgreementData.due_date,
        tenure: modifiedAgreementData.tenure,
        stayingFrom: modifiedAgreementData.staying_from,
        vacatingDate: modifiedAgreementData.vacating_on,
        advanceRent: originalAgreement?.is_advance_rent || false,
      };
    }
    return agreementData?.agreementDetails || {};
  };

  const currentAgreementDetails = getAgreementDetails();

  // Show error if no agreement data
  if (!isModifying && !agreementData?.agreementDetails) {
    return (
      <div className="p-8">
        <div className="text-center">
          <p className="text-gray-500">
            No agreement data found. Please start the agreement process again.
          </p>
          <button
            onClick={() =>
              navigate(`/dashboard/my-properties/${unitId}/add-agreement`)
            }
            className="mt-4 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
          >
            Start Agreement
          </button>
        </div>
      </div>
    );
  }

  // Show error if modify mode but no modified data
  if (isModifying && !modifiedAgreementData) {
    return (
      <div className="p-8">
        <div className="text-center">
          <p className="text-gray-500">
            No agreement modification data found. Please start the modification
            process again.
          </p>
          <button
            onClick={() => navigate(-1)}
            className="mt-4 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen w-full p-6">
      <div className="container mx-auto max-w-4xl">
        <h1 className="text-2xl font-bold mb-8">
          {isModifying ? "Review Agreement Changes" : "Agreement Overview"}
        </h1>

        {/* NEW: Modification Warning */}
        {isModifying && (
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
            <p className="text-yellow-800">
              ⚠️ You are about to modify agreement #{agreementId}. Please review
              all changes before confirming.
            </p>
          </div>
        )}

        {/* Tenants Section */}
        <section className="mb-8">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-semibold">
              {isModifying ? "Updated Tenants" : "Tenants"}
            </h2>
            <button
              onClick={() => navigate(-1)}
              className="text-blue-600 hover:text-blue-800 text-sm font-medium"
            >
              Edit
            </button>
          </div>
          <div className="bg-white rounded-lg shadow-sm border p-6">
            {validTenants.length > 0 ? (
              <div className="space-y-4">
                {validTenants.map((tenant, index) => (
                  <div
                    key={tenant.entity_id || `tenant-${index}`}
                    className="border border-gray-200 rounded-lg p-4"
                  >
                    <div className="flex items-start space-x-4">
                      {/* Profile Picture */}
                      <div
                        className="w-16 h-16 rounded-full flex-shrink-0 cursor-pointer"
                        onClick={async () => {
                          console.log("🖱️ Profile image clicked");
                          const imageUrl = getTenantProfileImageURL(tenant, {
                            quality: 80,
                          });
                          console.log("📸 Profile image URL:", imageUrl);

                          if (imageUrl) {
                            await viewImage(
                              imageUrl,
                              tenant,
                              "profile_picture"
                            );
                          } else {
                            console.log(
                              "❌ No profile image available for tenant:",
                              tenant
                            );
                            debugTenantData(tenant, "ProfileImageClick");
                            alert("No profile image available for this tenant");
                          }
                        }}
                      >
                        <CustomImage
                          location={
                            tenant.profile_picture?.location ||
                            tenant.media?.profile_picture?.location ||
                            null
                          }
                          className="w-full h-full rounded-full"
                          imageType={IMAGE_TYPES.PROFILE}
                          initials={getTenantInitials(
                            tenant.first_name,
                            tenant.last_name
                          )}
                          altText={`${tenant.first_name} ${tenant.last_name} profile picture`}
                          jwt={jwt}
                        />
                      </div>

                      {/* Tenant Info */}
                      <div className="flex-1">
                        <div className="flex items-center space-x-2">
                          <p className="font-medium text-gray-900">
                            {tenant.first_name} {tenant.last_name}
                          </p>
                          {index === 0 && (
                            <span className="bg-yellow-100 text-yellow-800 text-xs px-2 py-1 rounded-full font-medium">
                              Primary
                            </span>
                          )}
                          {tenant.tenant_in_db && (
                            <span className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full font-medium">
                              Existing
                            </span>
                          )}
                          {tenant.tenant_in_agreement && (
                            <span className="bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full font-medium">
                              From Agreement
                            </span>
                          )}
                        </div>
                        <p className="text-sm text-gray-500 mt-1">
                          {tenant.mobile}
                        </p>

                        {/* Documents */}
                        <TenantDocuments tenant={tenant} />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-gray-500">
                No tenants added for this agreement.
              </p>
            )}
          </div>
        </section>

        {/* Agreement Details Section */}
        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">
            {isModifying ? "Updated Agreement Details" : "Agreement Details"}
          </h2>
          <div className="bg-white rounded-lg shadow-sm border p-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <h3 className="font-medium text-gray-700 mb-3">
                  Financial Details
                </h3>
                <div className="space-y-2">
                  <div className="flex justify-between">
                    <span className="text-gray-600">Monthly Rent:</span>
                    <span className="font-medium">
                      ₹{currentAgreementDetails.monthlyRent}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Security Deposit:</span>
                    <span className="font-medium">
                      ₹{currentAgreementDetails.securityDeposit}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Maintenance:</span>
                    <span className="font-medium">
                      ₹{currentAgreementDetails.maintenanceCharge}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Advance Rent:</span>
                    <span className="font-medium">
                      {currentAgreementDetails.advanceRent ? "Yes" : "No"}
                    </span>
                  </div>
                </div>
              </div>

              <div>
                <h3 className="font-medium text-gray-700 mb-3">
                  Agreement Terms
                </h3>
                <div className="space-y-2">
                  <div className="flex justify-between">
                    <span className="text-gray-600">Due Date:</span>
                    <span className="font-medium">
                      {currentAgreementDetails.formattedDueDate} of every month
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Tenure:</span>
                    <span className="font-medium">
                      {currentAgreementDetails.tenure}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Staying From:</span>
                    <span className="font-medium">
                      {new Date(
                        currentAgreementDetails.stayingFrom
                      ).toLocaleDateString()}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Vacating On:</span>
                    <span className="font-medium">
                      {new Date(
                        currentAgreementDetails.vacatingDate
                      ).toLocaleDateString()}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Unit Details Section */}
        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Unit Details</h2>
          <div className="bg-white rounded-lg shadow-sm border p-6">
            {unitDetails?.unit || originalAgreement ? (
              <div className="space-y-2">
                <div className="flex justify-between">
                  <span className="text-gray-600">Unit Name:</span>
                  <span className="font-medium">
                    {unitDetails?.unit?.unit_name ||
                      originalAgreement?.unit_name}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Building:</span>
                  <span className="font-medium">
                    {unitDetails?.unit?.building_name ||
                      originalAgreement?.building_name}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Address:</span>
                  <span className="font-medium">
                    {unitDetails?.unit?.address || "N/A"}
                  </span>
                </div>
              </div>
            ) : (
              <p className="text-gray-500">Loading unit details...</p>
            )}
          </div>
        </section>

        {/* Action Buttons */}
        <div className="flex justify-between">
          <button
            onClick={() => navigate(-1)}
            disabled={loading}
            className="px-6 py-3 bg-gray-500 text-white rounded-lg hover:bg-gray-600 disabled:opacity-50"
          >
            Back
          </button>

          <CustomButton
            tailwindClasses={`px-8 py-3 text-lg font-medium ${
              loading
                ? "bg-gray-400 text-gray-700 cursor-not-allowed"
                : isModifying
                  ? "bg-orange-500 text-white hover:bg-orange-600"
                  : "bg-green-500 text-white hover:bg-green-600"
            }`}
            label={
              loading
                ? isModifying
                  ? "Updating..."
                  : isUpdate
                    ? "Updating..."
                    : "Creating..."
                : isModifying
                  ? "Confirm Changes"
                  : isUpdate
                    ? "Update Agreement"
                    : "Create Agreement"
            }
            onClick={handleAgreementAction}
            disabled={loading}
          />
        </div>

        {error && <p className="text-red-500 mt-4 text-right">{error}</p>}

        {/* Congratulations Modal (only for create flow) */}
        {/* {isModalOpen && agreementResponse && !isModifying && (
          <CongratsModal
            open={isModalOpen}
            onClose={handleModalCloseAndNavigate}
            agreementData={currentAgreementDetails}
            tenantData={
              createdTenants.length > 0 ? createdTenants : validTenants
            }
            unitData={unitDetails?.unit}
            addAgreement={agreementResponse}
          />
        )} */}

        {isModalOpen && agreementResponse && (
          <CongratsModal
            open={isModalOpen}
            onClose={
              isModifying
                ? handleModifyModalCloseAndNavigate
                : handleModalCloseAndNavigate
            }
            agreementData={currentAgreementDetails}
            tenantData={
              createdTenants.length > 0 ? createdTenants : validTenants
            }
            unitData={unitDetails?.unit || originalAgreement}
            addAgreement={agreementResponse}
            isUpdate={isUpdate}
            isModify={isModifying} // Pass the modify flag
            originalData={originalAgreement} // Pass original agreement data
            modifiedData={modifiedAgreementData} // Pass modified data
          />
        )}

        {/* Image Modal */}
        {isImageModalOpen && selectedImage && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75 z-50">
            <div className="relative max-w-4xl max-h-screen p-4">
              <button
                onClick={() => setImageModalOpen(false)}
                className="absolute top-2 right-2 text-white hover:text-gray-300 text-2xl z-10"
              >
                ×
              </button>
              <img
                src={selectedImage}
                alt="Document preview"
                className="max-w-full max-h-full object-contain"
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AgreementOverview;
